<template>
    <el-form :model="ruleForm" :rules="rules" ref="resetPasswordForm" label-width="0" class="mobile-form login-form">
        <div>
            <el-form-item label="" prop="mobile" class="mobile">
                <el-input type="text" v-model.trim="ruleForm.mobile" auto-complete="off" class="login-input pass-input" placeholder="手机号/邮箱" style="width: 110px"></el-input>
            </el-form-item>
            <el-form-item label="" prop="code" class="codeImg">
                <el-input type="text" placeholder="图片验证码" class="login-input pass-input" v-model.trim="ruleForm.code" auto-complete="off" maxlength="5"></el-input>
                <img :src="url" @click="getImage" />
            </el-form-item>
        </div>

        <el-form-item label="" prop="sms_code" class="vercode">
                <el-input type="text" v-model.trim="ruleForm.sms_code" auto-complete="off" class="login-input pass-input" style="width: 100px" placeholder="请输入验证码"></el-input>
                <el-button @click="getSmsCode" v-if="!count" class="login-btn">获取验证码</el-button>
                <el-button v-else class="login-btn">{{ count }}秒后获取</el-button>
            </el-form-item>
        <el-form-item label="" prop="password">
            <el-input type="password" v-model.trim="ruleForm.password" autocomplete="new-password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="" prop="confirm_password">
            <el-input type="password" v-model.trim="ruleForm.confirm_password" auto-scomplete="off" placeholder="新密码确认"></el-input>
        </el-form-item>
        <el-form-item class="submit-item">
            <el-button class="submit-btn" type="primary" @click="submit" :disabled="loginStatus" :loading="loginStatus">
                重置密码
            </el-button>
            <button class="go-back-login" type="button" @click="goBack">返回登录</button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    data() {
        var validateMobile = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入手机号/邮箱"));
            } else {
                let reg = /^1[0-9]{10}/;
                let reg1 = /^([A-Za-z0-9]*[-_\.]?[A-Za-z0-9]+)*[A-Za-z0-9\._-]@[a-zA-Z\d]+\.[a-zA-Z]{1,5}$/
                if(!reg.test(value) && !reg1.test(value)) {
                callback(new Error("请输入正确的手机号/邮箱"));
                }
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入新密码"));
            } else {
                var reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[\.,#?!@$%^&*-].*)[0-9A-Za-z\.,#?!@$%^&*-]{12,32}$/;
                if (!reg.test(this.ruleForm.password)) {
                    callback(new Error("密码由12-32位数字、大/小写字母、常用特殊字符组成"));
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入新密码"));
            } else if (value !== this.ruleForm.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            // url: `${Login.imageCode}?captcha_type=login&raodom=${Math.random()}`,
            url: "",
            ruleForm: {
                mobile: "",
                sms_code: "", // 手机验证码
                sms_type: "findPassword",
                code: "", // 图片验证码
                code_key: "", // 图片验证码key值 传递后台进行比较
                password: "",
                confirm_password: "",
            },
            count: null,
            timer: null,
            loginStatus: false,
            rules: {
                mobile: [
                    { validator: validateMobile, trigger: "blur" }
                ],
                sms_code: [
                    { required: true, message: "请输入验证码", trigger: "blur" },
                ],
                code: [
                    { required: true, message: "请输入图形验证码", trigger: "blur" },
                ],
                password: [{ validator: validatePass, trigger: "blur" }],
                confirm_password: [{ validator: validatePass2, trigger: "blur" }],
            },
            codeClick : false,
        };
    },
    created() {
        this.getImage()
    },
    methods: {
        async getImage() {
            loginSdk.requestAction("image_code", {}).then(res => {
                if (res.code == 0) {
                    this.url = res.data.base64
                    this.ruleForm.code = "";
                    this.ruleForm.code_key = res.data.key;
                    
                }
            })
            
        },
        async getSmsCode() {
            if (!this.ruleForm.mobile) {
                this.$refs["resetPasswordForm"].validateField("mobile");
                return false;
            }
            if (!this.ruleForm.code) {
                this.$refs["resetPasswordForm"].validateField("code");
                return false;
            }
            if(this.codeClick){
                return false;
            }
            this.codeClick = true;

            if(this.ruleForm.mobile.indexOf('@') > 0) {
                this.sendCodeApi("email_code", {type: 4, email: this.ruleForm.mobile, codekey:this.ruleForm.code_key, imgcode:this.ruleForm.code})
            }else {
                this.sendCodeApi("mes_send", {type: 4, mobile: this.ruleForm.mobile, codekey:this.ruleForm.code_key, imgcode:this.ruleForm.code})
            }
            
            
        },
        // 请输入验证码
        sendCodeApi(url, params){
            loginSdk.requestAction(url,params).then(res=>{
                if (res.code == 0) {
                    this.$message.success('发送成功');
                    const TIME = 60;
                    if (!this.timer) {
                        this.count = TIME;
                        this.timer = setInterval(() => {
                            if (this.count > 1 && this.count <= TIME) {
                                this.count--;
                            } else {
                                clearInterval(this.timer);
                                this.timer = null;
                                this.count = null;
                                this.codeClick = false;
                            }
                        }, 1000);
                    }else{
                        this.codeClick = false;
                        this.$message.error(res.msg)
                    }
                }else{
                    this.$message.error(res.msg)
                    this.codeClick = false;
                    this.getImage();  
                }
            }).catch(err=>{
                this.getImage();  
            });
        
		},
        submit() {
            this.$refs["resetPasswordForm"].validate((valid) => {
                if (valid) {
                    let { mobile, sms_code, password, confirm_password } = this.ruleForm;
                    let requestData = {
                        sms_code:sms_code,
                        code:sms_code,
                        password : password,
                        re_password : confirm_password
                    }
                    
                    let opUrl = '';
                    if(mobile.indexOf('@') > 0) {
                        requestData.email = mobile;
                        opUrl = "forget_email_password";
                    }else {
                        requestData.mobile = mobile;
                        opUrl = "forget_password";
                    }
                    loginSdk.requestAction(opUrl, requestData).then(res => {
                        if (res.code == 0) {
                                this.$message.success(res.msg)
                            this.$emit("goBack");
                        }else{
                            this.getImage()
                            this.$message.error(res.msg)
                        }
                    })
                    
                }
            });
        },
        goBack() {
            this.$emit("goBack");
        },
    },
};
</script>

<style lang="scss" scoped>
.submit-btn {
    text-align: center;
}
.submit-item {
    ::v-deep( .el-form-item__content){
        display: block;
    }
}
.go-back-login {
    display: block;
    margin: 20px auto 0;
    background: transparent;
}
</style>
